import { Box, Stack } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmDialog, CustomButton } from "../../../components";
import i18n from "../../../i18n-config";
import {
  deleteAsyncAdminUtilisateur,
  Utilisateur,
} from "../../../store/features/utilisateurSlice";
import { RootState } from "../../../store/state";
import theme from "../../../theme/theme";
import notifyMessage from "../../../utils/notify";
import { capitalizeFirstLetter } from "../../../utils/strings";
import GestionUserTable from "./GestionUserTable";
import RoleTable from "./RoleTable";
import UserForm from "./UserForm";

function GestionUser() {
  const [isRole, setIsRole] = useState(false);
  const [userModal, setUserModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Utilisateur>();

  const utilisateurs = useSelector((state: RootState) =>
    Object.values(state.utilisateur)
  );

  const dispatch = useDispatch();

  const toggleRole = (value: boolean) => {
    setIsRole(value);
  };

  const onEdit = (item: Utilisateur) => {
    setSelectedItem(item);
    openUserModal();
  };

  const openUserModal = () => {
    setUserModal(true);
  };

  const closeUserModal = () => {
    setUserModal(false);
  };

  const callback = () => {
    closeDeleteModal();
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("delete_success")),
      severity: "success",
    });
  };

  const onError = () => {
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("error_occured")),
      severity: "error",
    });
  };

  const openDeleteModal = (item: Utilisateur) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
  };

  const confirmDelete = () => {
    if (selectedItem) {
      dispatch(
        deleteAsyncAdminUtilisateur(selectedItem, callback, onError) as any
      );
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        pb: 3,
        pt: 0,
      }}
    >
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Stack direction="row" spacing={3}>
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("gestion_users"))}
            rootStyle={{
              height: 42,
              backgroundColor: !isRole ? "#00080C" : "#DDE4DD",
              width: "200px",
            }}
            titleStyle={{
              color: !isRole ? theme.colors.white : theme.colors.black,
              fontSize: 14,
            }}
            onClick={() => toggleRole(false)}
          />
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("role"))}
            rootStyle={{
              height: 42,
              backgroundColor: isRole ? "#00080C" : "#DDE4DD",
              width: "200px",
            }}
            titleStyle={{
              color: isRole ? theme.colors.white : theme.colors.black,
              fontSize: 14,
            }}
            onClick={() => toggleRole(true)}
          />
        </Stack>
        <CustomButton
          title={capitalizeFirstLetter(i18n.t("creer_utilisateur"))}
          rootStyle={{
            height: 42,
            width: "200px",
          }}
          titleStyle={{ color: theme.colors.white, fontSize: 14 }}
          onClick={openUserModal}
        />
      </Stack>

      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          p: 2,
        }}
      >
        {isRole ? (
          <RoleTable />
        ) : (
          <GestionUserTable
            data={utilisateurs}
            onEdit={onEdit}
            onDelete={openDeleteModal}
          />
        )}
      </Box>
      {userModal ? (
        <UserForm
          open={userModal}
          item={selectedItem}
          onClose={closeUserModal}
        />
      ) : null}
      <ConfirmDialog
        open={deleteModal}
        onClose={closeDeleteModal}
        title={i18n.t("supprimer")}
        message={i18n.t("supprimer_desc")}
        onConfirm={confirmDelete}
        btn1Text={i18n.t("non")}
        btn2Text={i18n.t("supprimer_ok")}
      />
    </Box>
  );
}

export default GestionUser;
